let _isEditorFlow = false;

export const setEditorFlow = () => (_isEditorFlow = true);
export const isEditorFlow = () => _isEditorFlow;
